import React from "react";
import { Link } from 'react-router-dom'
import { Container, Row, Col} from 'react-bootstrap'

function Footer()
{
  return(
      <>
<section id="footer">
  <Container>
     <Row>
      <Col lg={3} md={6} sm={12}>
        <div className="footer-logo">
          <img src="imgs/home_four/modren-appdorce-logo.png" alt=""/>
          <p>Modern Appforce is a robust media player that provides user friendly features to fulfill your needs. 
             In order to use Modern Appforce you need to add playlist of a service provider.</p>
        </div>
      </Col>
      <Col lg={6} md={6} sm={12}>
      <div className="footer-quick-content">
          <div className="footer-quick-heading">
            <h2>Quick Links</h2>
          </div>
          <ul className="footer-quick-link">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>
        
        <div className="fc-footer-note-heading">
          <h2>Modern Appforce Note:</h2>
        </div>
        <div className="footer-require-dflex">
          <ul>
            <li><i class="fa fa-check-square-o" aria-hidden="true"></i> Modern Appforce player does not sell playlists or subscriptions.</li>
            <li><i class="fa fa-check-square-o" aria-hidden="true"></i> It is a video media player and does not offer channels or include any content. 
                Please note, Modern Appforce player is not responsible for the content utilized within 
                our app.</li>
          </ul>
          <ul>
            <li><i class="fa fa-check-square-o" aria-hidden="true"></i> Please be advised that there are no refunds after purchase.</li>
            <li><i class="fa fa-check-square-o" aria-hidden="true"></i> The app offers a 3-day trial period for testing purposes. After this period, a license 
                 must be purchased to continue using the app.</li>
          </ul>
        </div>
     
      </Col>
      <Col lg={3} md={6} sm={12}>
        <div className="footer-con-info">
          <div className="footer-con-heading">
             <h2>Contact Us</h2>
           </div> 
        <div className="footer-mail-link">
          <span>Email:</span><br/>
          <a href="mailto:info@modernappforce.com">info@modernappforce.com</a>
        </div>
        <div className="footer-download-link">
          <span>Download:</span><br/>
          <a href="/install-modern-appforce">Download Modern Appforce</a>
        </div>
        <div className="footer-payment-link">
        <span>Payment Method:</span><br/>
          <div class="payment-method-dflex">
            <div class="payment-method-col"><img class="alignnone size-medium wp-image-16482" src="http://appforcepro.com/wp-content/uploads/2024/11/visa-card-400x256.png" alt="" width="400" height="256" /></div>
            <div class="payment-method-col"><img class="alignnone size-medium wp-image-16483" src="http://appforcepro.com/wp-content/uploads/2024/11/master-card-400x257.png" alt="" width="400" height="257" /></div>
            <div class="payment-method-col stripe-pay"><img class="alignnone size-medium wp-image-16484" src="http://appforcepro.com/wp-content/uploads/2024/11/stripe-payment-400x225.png" alt="" width="400" height="225" /></div>
          </div>
        </div>
        </div>
      </Col>
     </Row>
  </Container>
</section>

<section id="footer-pdm">
  <div className="container">
      <div className="footer-pdm-link">
          <p> © Copyright 2025 <span className="fcls-text">Modern Appforce</span>. Designed By <span>Genboniya Tech</span></p>
      </div>
  </div>
</section>
      </>
    )
}
export default Footer